// Brick Buster — bounce the ball, smash every brick.
export function createBreakout(host) {
  const { ctx, input } = host; const W = host.W, H = host.H;
  const pw = 70, ph = 12, py = H - 30; let px = W / 2 - pw / 2;
  let ball, launched, lives = 3, bricks = [];
  const cols = 8, brickW = W / cols, brickH = 22, top = 60, rows = 5;
  const build = () => { bricks = []; for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) bricks.push({ x: c * brickW, y: top + r * brickH, alive: true, c: ["#f87171", "#fb923c", "#fbbf24", "#34d399", "#22d3ee"][r] }); };
  const reset = () => { launched = false; ball = { x: W / 2, y: py - 10, vx: 0, vy: 0 }; };
  build(); reset();
  return {
    dim: "2d", w: W, h: H, controls: ["left", "right", "a"], score: 0, over: false,
    frame(dt) {
      if (input.held.left) px -= 320 * dt; if (input.held.right) px += 320 * dt; px = Math.max(0, Math.min(W - pw, px));
      if (!launched) { ball.x = px + pw / 2; ball.y = py - 10; if (input.taps.includes("a")) { launched = true; ball.vx = 150 * (Math.random() < .5 ? -1 : 1); ball.vy = -280; } }
      else {
        ball.x += ball.vx * dt; ball.y += ball.vy * dt;
        if (ball.x < 6) { ball.x = 6; ball.vx *= -1; } if (ball.x > W - 6) { ball.x = W - 6; ball.vx *= -1; } if (ball.y < 6) { ball.y = 6; ball.vy *= -1; }
        if (ball.y > py && ball.y < py + ph && ball.x > px && ball.x < px + pw && ball.vy > 0) { ball.vy *= -1; ball.vx += (ball.x - (px + pw / 2)) * 3; host.sfx.click?.(); }
        if (ball.y > H + 10) { lives--; host.sfx.hit?.(); if (lives <= 0) this.over = true; else reset(); }
        for (const b of bricks) if (b.alive && ball.x > b.x && ball.x < b.x + brickW && ball.y > b.y && ball.y < b.y + brickH) { b.alive = false; ball.vy *= -1; this.score += 10; host.sfx.coin?.(); break; }
        if (!bricks.some((b) => b.alive)) { build(); reset(); }
      }
      ctx.fillStyle = "#05060f"; ctx.fillRect(0, 0, W, H);
      bricks.forEach((b) => { if (!b.alive) return; ctx.fillStyle = b.c; ctx.fillRect(b.x + 2, b.y + 2, brickW - 4, brickH - 4); });
      ctx.fillStyle = "#22d3ee"; ctx.fillRect(px, py, pw, ph);
      ctx.fillStyle = "#fde68a"; ctx.beginPath(); ctx.arc(ball.x, ball.y, 6, 0, 7); ctx.fill();
      ctx.fillStyle = "#f472b6"; ctx.font = "16px monospace"; ctx.fillText("\u2665".repeat(lives), 8, H - 8);
    },
  };
}
